import React from 'react';

const Footer = () => {
    return (
        <>
       {/*  <footer className="footer bg-dark text-light py-4">
            <div className="container">
                <div className="d-flex flex-column flex-md-row justify-content-center align-items-center">
                <div className="text-center">
                        <span className="text-muted">2025&copy; </span>
                        <a href="#" className="text-light text-decoration-none text-center text-hover-primary fw-semibold">
                        All Rights Reserved
                        </a>
                    </div>                
                </div>
            </div>
        </footer> */}
        </>
    );
};

export default Footer;
